import { render, staticRenderFns } from "./PesticideResidue.vue?vue&type=template&id=5819cf92&scoped=true"
import script from "./PesticideResidue.vue?vue&type=script&lang=js"
export * from "./PesticideResidue.vue?vue&type=script&lang=js"
import style0 from "./PesticideResidue.vue?vue&type=style&index=0&id=5819cf92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5819cf92",
  null
  
)

export default component.exports